import TransSummaryInfo from './trans-summary-info/trans-summary-info.vue';
import TransNavList from './trans-nav-list/trans-nav-list.vue';
import TransLandInfo from './trans-land-info/trans-land-info.vue';
import TransLands from './trans-lands/trans-lands.vue';
import TransBasicInfo from './trans-basic-info/trans-basic-info.vue';
import TransIssuesInfo from './trans-issues-info/trans-issues-info.vue';
import TransPromiseInfo from './trans-promise-info/trans-promise-info.vue';
import TransSceneInfo from './trans-scene-info/trans-scene-info.vue';
import TransConditionInfo from './trans-condition-info/trans-condition-info.vue';
import TransSignupInfo from './trans-signup-info/trans-signup-info.vue';
import TransBondInfo from './trans-bond-info/trans-bond-info.vue';
import TransSolicitationInfo from './trans-solicitation-info/trans-solicitation-info.vue';
import TransBiddingtimeInfo from './trans-biddingtime-info/trans-biddingtime-info.vue';
import TransDeliveryInfo from './trans-delivery-info/trans-delivery-info.vue';
import TransServiceInfo from './trans-service-info/trans-service-info.vue';
import TransEnclosureInfo from './trans-enclosure-info/trans-enclosure-info.vue';
import TransactionProService from '../transaction-pro-service';
import ProcurementGuidelines from './procurement-guidelines/procurement-guidelines.vue';
import Service from '@/service/index.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    TransSummaryInfo, // 头部信息
    TransNavList, // 导航
    TransLands, // 死数据的标信息
    TransLandInfo, // 标的信息
    TransBasicInfo, // 项目基本信息
    TransIssuesInfo, // 瑕疵声明及重大事项提示
    TransPromiseInfo, // 出租方承诺
    TransSceneInfo, // 现场勘验
    TransConditionInfo, // 承租方资格条件
    TransSignupInfo, // 交易报名
    TransBondInfo, // 竞价保证金及处置方式
    TransSolicitationInfo, // 征集意向受让方
    TransBiddingtimeInfo, // 竞价时间
    TransDeliveryInfo, // 标的交割
    TransServiceInfo, // 咨询信息
    TransEnclosureInfo, // 附件下载
    ProcurementGuidelines // 竞买须知
  },
  data () {
    return {
      id: '',
      detail: {}, // 竞买须知详情
      type: '', // 判断是水库还是校舍
      projectInfo: null, // 项目信息
      bidInfo: null, // 地块信息
      transfereeInfo: null, // 受让信息
      attachmentInfo: null, // 附件信息
      commitmentInfo: null, // 承诺书信息
      dialogFormVisible: false, // 竞买须知
      isDisabled: true,
      userInfo: null,
      bidTypeArr: null,
      qualificationRestrictionList: [],
      unBidSelArr: [],
      assignmentConditionArr: [],
      ileInfo: [], // 项目文件
      docUrlText: '', // 合同名称
      downloadAttachmentUrl: {

      },
      status: '', // 传过来的状态
      subjectMortgageList: [],
      subjectTitleList: [],
      citytitle: '',
      trading: [
        { name: '项目申请', img: require('@/assets/images/home/jylc/项目申请.png') },
        { name: '项目审核', img: require('@/assets/images/home/jylc/项目审核.png') },
        { name: '项目挂牌', img: require('@/assets/images/home/jylc/项目挂牌.png') },
        { name: '报名登记', img: require('@/assets/images/home/jylc/报名登记.png') },
        { name: '组织竞价', img: require('@/assets/images/home/jylc/组织竞价.png') },
        { name: '成交确认', img: require('@/assets/images/home/jylc/成交确认.png') },
        { name: '合同签订', img: require('@/assets/images/home/jylc/合同签订.png') },
        { name: '资金结算', img: require('@/assets/images/home/jylc/资金结算.png') },
        { name: '交易鉴证', img: require('@/assets/images/home/jylc/交易鉴证.png') }
      ],
      getProjectvideolist: []
    };
  },
  created () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.id = this.$route.query.id;
    this.type = this.$route.query.id;
    this.status = this.$route.query.status;
    this.getAttachmentInfo();
    this.getProjectDetail();
    if (this.id) {
      this.getTransProjectDetail('PROJECT'); // 获取详情信息
      this.getTransProjectDetail('USER'); // 获取用户和项目联系人信息
    }
    // this.getProjectContractUrl();
    const arr = [
      ['unBidSelArr', 'NOT_SOLICITED_CHOOSE'],
      ['bidTypeArr', 'BIDDING_METHOD'],
      ['qualificationRestrictionList', 'QUALIFICATION_RESTRICTION'],
      ['subjectMortgageList', 'SUBJECT_MORTGAGE'],
      ['subjectTitleList', 'SUBJECT_TITLE_CERTIFICATE_SITUATION']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.$store.commit('UPDATE_TRANSACTION_INFO', []);
  },
  watch: {
    transfereeInfo (newObj) {
      if (newObj) {
        // console.log(newObj && newObj.assignmentCondition && String(newObj.assignmentCondition));
        this.assignmentConditionArr = newObj && newObj.assignmentCondition && newObj.assignmentCondition.toString().split('\n');
        // console.log(this.assignmentConditionArr);
      }
    }
  },
  computed: {
    ...mapGetters([
      'isSignin'
    ]),
    noticeEndTimeHoursAdd1 () {
      const str = this.projectInfo && this.projectInfo.noticeEndTime;
      if (str) {
        const timeStr = new String(str).substr(0, 19).replace(/\-/g, '/').replace(/\T/g, ' ');
        return this.formatDate(new Date(new Date(timeStr).getTime() + 3600000 * 16 + 8 * 60 * 60 * 1000), 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    unBidSelText () {
      const str = this.transfereeInfo && this.transfereeInfo.unBidSel;
      const item = this.unBidSelArr && this.unBidSelArr.find(item => item.code === String(str));
      if (str === 2) {
        return item && (item.value + '，' + item.description) || '';
      }
      return item && item.value || '';
    },
    projectCode () {
      if (this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  },
  methods: {
    getAttachmentInfo () {
      TransactionProService.getRollOutProjectDetail({
        projectId: this.id,
        echoCode: 'FILE'
      }).then(res => {
        this.attachmentInfo = res.data;
        const obj = res.data.files.find(item => item.projectFileType === 26);
        this.getProjectvideolist = obj && obj.filePaths || [];
      });
    },
    getTransProjectDetail (echoCode) {
      TransactionProService.getTransProjectDetail({
        projectId: this.id,
        echoCode: echoCode
      }).then(res => {
        if (res && res.code === '0') {
          if (echoCode === 'PROJECT') {
            this.detail = res.data;
          } else {
            this.userInfo = res.data;
          }
        }
      });
    },
    // 点击去报名
    onSignUp () {
      this.dialogFormVisible = true;
    },
    // 同意按钮
    onAgree () {
      if (this.isDisabled) { return; }
      this.dialogFormVisible = false;
      this.$router.push('/transaction-pro/signup?id=' + this.id);
    },
    enabledBtn () {
      this.isDisabled = false;
    },
    getProjectDetail () {
      const obj = {
        PROJECT: 'projectInfo',
        ASSIGNMENT: 'transfereeInfo',
        // FILE: 'attachmentInfo',
        PROMISE: 'commitmentInfo',
        BID: 'bidInfo',
        BIDDING_METHOD: 'bidTypeArr'
      };
      Object.keys(obj).forEach(key => {
        TransactionProService.getRollOutProjectDetail({
          projectId: this.id,
          echoCode: key
        }).then(res => {
          this[obj[key]] = res && res.data;
          // console.log(this.projectInfo, 111);
          if (key === 'PROJECT') {
            if (this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
              this.isSignin && this.getDownloadAttachmentUrl();
              this.getProjectContractUrl();
            }
          }
        });
      });
      // console.log(this.projectInfo, 111);
    },
    getProjectImg () {
      if (this.attachmentInfo && this.attachmentInfo.files) {
        const obj = this.attachmentInfo.files.find(item => item.projectFileType === 1);
        return obj.filePaths;
      } else {
        return [];
      }
    },
    formatDate (date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    },
    getDownloadAttachmentUrl () {
      TransactionProService.getDownloadAttachmentUrl(this.projectInfo.projectType, this.projectInfo.projectSubType).then(res => {
        if (res && res.code === '0') {
          this.downloadAttachmentUrl.applyBookUrl = res.data.applyBookUrl;
          this.downloadAttachmentUrl.contractUrl = res.data.contractUrl;
          this.downloadAttachmentUrl.authBookUrl = res.data.authBookUrl;
        }
      });
    },
    getProjectContractUrl () {
      TransactionProService.getProjectContractUrl({
        projectId: this.id,
        projectType: 1
        // contractType: 3
      }).then(res => {
        if (res && res.code === '0') {
          this.downloadAttachmentUrl.docUrl = res && res.data && res.data.url;
          this.docUrlText = res && res.data && res.data.contractName;
        }
      });
    },
    openWindow (key) {
      // 判断是否登录
      if (!this.isSignin) {
        this.$router.push('/signin');
        return;
      }
      if (key === 'docUrl') {
        window.open(this.downloadAttachmentUrl[key]);
      } else {
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = 'data:file/doc;base64,' + this.downloadAttachmentUrl[key];
        if (key === 'applyBookUrl') {
          link.download = '受让方申请书.doc';
          if (['6-1', '7-2'].includes(this.projectCode)) {
            link.download = '承租方申请书.doc';
          }
        } else if (key === 'authBookUrl') {
          link.download = '授权委托书.doc';
        } else if (key === 'contractUrl') {
          link.download = '产权交易合同模板.doc';
        }
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(link.href);
      }
    },
    openPDF (url) {
      window.open(url);
    },
    // 下载模版
    downTemplate () {
      // window.open('/交易保证金的注意事项.pdf');
    }
  }
};
